import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { AllCommunityModules } from '@ag-grid-community/all-modules';
import { SOURCE_COL_DEFS } from 'src/common/algo-column-definitions';
import { USER_ID } from 'src/common/keys';
import { ConfigurationService } from 'src/services/configuration.service';
import { LocalstorageService } from 'src/services/localstorage.service';
import { NgxToasterService } from 'src/services/ngx-toaster.service';
@Component({
  selector: 'app-source',
  templateUrl: './source.component.html',
  styleUrls: ['./source.component.css']
})
export class SourceComponent implements OnInit {
  public registerForm: FormGroup;
  public submitted = false;
  public isEdit = false;
  public columnDefs = SOURCE_COL_DEFS;
  private gridApi: any;
  public getRowHeight;
  public  headerHeight;
  public sourceList = [];
  public gridOptions: any;
  public modules = AllCommunityModules;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public location: Location,
    public spinner: NgxSpinnerService,
    public toastr: NgxToasterService,
    public configurationService: ConfigurationService,
    public storage: LocalstorageService) {
    this.gridOptions = {
      frameworkComponents: {
      },
      pagination: true,
      paginationAutoPageSize: true,
    };
    this.headerHeight = 40;
    this.gridOptions.getRowHeight = function(params) {
      return 40;
    };
  }

  ngOnInit() {
    this.populateList();
    this.initializeForm();
  }
  public populateList = () => {
    this.configurationService.getAllSources({ clientId: 1 }).subscribe((res: any) => {
      this.sourceList = res.data;
    });
  }
  initializeForm() {
    this.registerForm = this.formBuilder.group({
      sourcingId: [0],
      clientId: [1, Validators.required],
      sourcingName: ['', Validators.required],
      description: ['', Validators.required],
      active: [true],
      currentUserId: [this.storage.get(USER_ID)]
    });
  }
  populateForm(event): void {
    if (event && event.data) {
      this.isEdit = true;
      const dataToPopulate = event.data;
      Object.keys(this.registerForm.controls).forEach(key => {
        if (dataToPopulate[key]) {
          this.registerForm.controls[key].setValue(dataToPopulate[key]);
        }
      });
    }
  }
  public onSubmit = () => {
    this.submitted = true;
    if (this.registerForm.valid) {
      const model = { ...this.registerForm.value };
      this.spinner.show();
      if (this.isEdit) {
        this.configurationService.updateSource(model).subscribe(res => {
          this.populateList();
          this.isEdit = false;
          this.submitted = false;
          this.initializeForm();
          this.spinner.hide();
        }, error => {

        });
      } else {
        this.configurationService.addSource(model).subscribe(res => {
          this.populateList();
          this.submitted = false;
          this.initializeForm();
          this.spinner.hide();
        }, error => {
          this.spinner.hide();
        });
      }
    }
  }
  Cancel_Click() {
    this.submitted = false;
    this.isEdit = false;
    this.initializeForm();
  }
  onGridReady(params) {
    this.gridApi = params.api;
  }
}
